// --- Redux
import { useDispatch } from 'react-redux';

/**
 * useLoading Hook
 *
 * This hook provides functions to manage the loading state in the Redux store.
 * It allows components to show or hide a loading spinner.
 *
 * @hook
 * @returns {Object} An object containing functions to set the loading state.
 **/
export function useLoading() {
    const d = useDispatch();
    function setLoadingTrue() {
        d({ type: 'SHOW_SPINNER', showSpinner: true });
    }
    function setLoadingFalse() {
        d({ type: 'SHOW_SPINNER', showSpinner: false });
    }
    return { setLoadingTrue, setLoadingFalse };
}
